import type { ReactNode } from "react";
import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import type { MetadataEvent } from "~/pages/product-details/tabs/sales-data-tab/hooks/use-metadata-events";
import { GenerationTooltipContent } from "./generation-tooltip-content";
import { OnixImportTooltipContent } from "./onix-import-tooltip-content";

const eventTooltipContent = (
  event: MetadataEvent,
  t: TFunction<["productDetails"]>,
): ReactNode => {
  switch (event.type) {
    case "ONIX_IMPORT":
      return <OnixImportTooltipContent event={event} />;
    case "GENERATION":
      return <GenerationTooltipContent event={event} />;
    case "RELEASE_DATE":
      return t("productDetails:salesData.events.releaseDate.tooltip");
    default:
      throw new Error(`Unhandled metadata event type: ${event.type}`);
  }
};

export const MetadataEventMarkerTooltip = ({
  events,
}: {
  events: MetadataEvent[];
}) => {
  const { t } = useTranslation(["productDetails"]);

  return (
    <div className="space-y-2">
      {events.map((event, index) => (
        <div
          key={event.id}
          className={index > 0 ? "border-t border-border pt-2" : undefined}
        >
          {eventTooltipContent(event, t)}
        </div>
      ))}
    </div>
  );
};
